import { Divider, PageWrapper } from '@qonsoll/react-design'

import { AuthOptions } from 'domains/Session/components'
import { useTranslations } from '@qonsoll/translation'

const Register = () => {
  const { t } = useTranslations()
  const headingProps = {
    title: t('Thanks for the tip') + '!',
    titleSize: 3,
    marginBottom: 4,
    textAlign: 'center'
  }

  return (
    <PageWrapper
      headingProps={headingProps}
      alignMiddle
      contentWidth={['100%', '100%', 400]}>
      <Divider style={{ margin: '0 0 32px 0' }} />

      <AuthOptions isLogin={false} />
    </PageWrapper>
  )
}

export default Register
